import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["styles"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
export default (function (_ref) {
  var _ref$styles = _ref.styles,
      styles = _ref$styles === void 0 ? {} : _ref$styles,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5262 4.47021c-.1447.0858-.2856.17756-.4224.27495l-.0746.05394c-.3804.27966-.7271.60335-1.0292.96372-.3021-.36037-.6488-.68406-1.0292-.96372l-.0746-.05394c-.1368-.09739-.2777-.18915-.4224-.27495-.88977-.52781-1.91892-.8302-2.9738-.8302-3.08 0-5.5 2.45798-5.5 5.58632 0 3.83617 3.39442 6.96257 8.5373 11.69927l.0127.0117L12 22.278l1.45-1.3306.0395-.0364C18.6174 16.178 22 13.0558 22 9.22633c0-3.12834-2.42-5.58632-5.5-5.58632-1.0549 0-2.084.30239-2.9738.8302zM12.0978 19.4738l.0351-.0324c2.6034-2.4029 4.603-4.2552 5.9755-5.964C19.457 11.7984 20 10.4959 20 9.22633c0-2.05324-1.5538-3.58632-3.5-3.58632-.7825 0-1.5706.26219-2.2307.73047l-.061.04409c-.2524.18629-.4798.39957-.6757.6332L12 8.87577l-1.5326-1.828c-.1959-.23363-.4233-.44691-.67575-.6332l-.06096-.0441c-.6601-.46828-1.44817-.73046-2.23069-.73046-1.94618 0-3.5 1.53308-3.5 3.58632 0 1.27177.54487 2.57647 1.89815 4.25797 1.37716 1.7112 3.38315 3.5654 5.99415 5.9702l.0155.0143.0974.09.0882-.0809.0044-.0041z",
    fill: "currentColor"
  }));
});